//export const simpleFilterFields = ['searchTerm'] as const;

export const osStandardFilterFields = [
	'parameterId',
	'parameterRef',
	'organizationId',
	'label',
	'parameterType',
] as const;

export const osDateFilterFields = ['createdAt', 'updatedAt'] as const;

export const filterFields = [...osStandardFilterFields, ...osDateFilterFields] as const;
